import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../js/reflectRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var SequenceClass;
function Sequence() {
  if (SequenceClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'Sequence');
    SequenceClass = $;
  }
  return SequenceClass;
}
function Sequence$iterator$ref() {
  return constructCallableReference((p0) => p0.iterator_jk1svi_k$(), 1, 0, 1, 'iterator');
}
//region block: exports
export {
  Sequence$iterator$ref as Sequence$iterator$ref2j76hcuuhqjnf,
  Sequence as Sequence1quqbxersk0bb,
};
//endregion

//# sourceMappingURL=Sequence.mjs.map
